function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.5 32.7V3.9H11.9c-1.1 0-2 .9-2 2v2.6h2c1.1 0 2 .9 2 2s-.9 2-2 2H8c-1.1 0-2 .9-2 2s.9 2 2 2 2 .9 2 2v2h2c1.1 0 2 .9 2 2s-.9 2-2 2H8c-1.1 0-2 .9-2 2s.9 2 2 2 2 .9 2 2v2h2c1.1 0 2 .9 2 2s-.9 2-2 2H8c-1.1 0-2 .9-2 2s.9 2 2 2 2 .9 2 2v2.6c0 1.1.9 2 2 2h32.6v-3.9c0-1.1.9-2 2-2s2 .9 2 2v5.9c0 1.1-.9 2-2 2H11.9c-3.3 0-5.9-2.6-5.9-5.9v-.9c-3.1-1.1-4.7-4.5-3.6-7.5.6-1.7 1.9-3 3.6-3.6v-.7c-3.1-1.1-4.7-4.5-3.6-7.6.6-1.7 1.9-3 3.6-3.6V20c-3.1-1.1-4.7-4.5-3.6-7.6.6-1.7 1.9-3 3.6-3.6V5.9C6 2.6 8.6 0 11.9 0h34.6c1.1 0 2 .9 2 2v30.8c0 1.1-.9 2-2 2s-2-1-2-2.1zm-21.7-8.9c-1.8-2.7-1.1-6.4 1.7-8.2s6.4-1.1 8.2 1.7c1.3 2 1.3 4.6 0 6.5 2.6 1.4 4.4 3.9 5 6.7v.1c.2 1 0 2.1-.7 2.8-.6.8-1.6 1.2-2.6 1.2H21.1c-1.9 0-3.4-1.5-3.4-3.4 0-.2 0-.5.1-.7.6-2.8 2.4-5.3 5-6.7zm5-1.3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8.3h11.9c-1.1-3.3-4.6-5.1-7.8-4-2 .5-3.5 2-4.1 4z"
});

var SvgIcnContatti = function SvgIcnContatti(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 50.5 50.5",
    fill: "#fff",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcnContatti, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_contatti.4e5557d2.svg";
export { ForwardRef as ReactComponent };